import { ActionButton, Grid, Typography } from '@up2rent/ui';
import { useIntl } from 'react-intl';

interface ReadAccessSyncErrorProps {
  onRetry: () => void;
}

const ReadAccessSyncError = ({ onRetry }: ReadAccessSyncErrorProps) => {
  const { formatMessage } = useIntl();
  return (
    <Grid
      column
      style={{
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        minHeight: '100vh',
        gap: 16,
      }}
    >
      <Typography title bold>
        {formatMessage({ id: 'error.readAccessSync.title' })}
      </Typography>
      <Typography>{formatMessage({ id: 'error.readAccessSync.body' })}</Typography>
      <ActionButton onClick={onRetry}>{formatMessage({ id: 'error.readAccessSync.retry' })}</ActionButton>
    </Grid>
  );
};

export default ReadAccessSyncError;
